"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTabDefaultProps = exports.createTabTheme = void 0;
exports.createTabTheme = function (_a) {
    var _b;
    var palette = _a.palette, breakpoints = _a.breakpoints;
    return ({
        root: (_b = {
                minHeight: 36.5
            },
            _b[breakpoints.up("xs")] = {
                minWidth: 80,
            },
            _b.textTransform = "none",
            _b.letterSpacing = "initial",
            _b),
        textColorInherit: {
            color: palette.neutral.grey60,
            "&$selected": {
                color: palette.neutral.grey36,
            },
        },
    });
};
exports.createTabDefaultProps = function () { return ({}); };
